import { BaseService } from 'src/app/shared/services/base.service';
import * as i0 from "@angular/core";
import * as i1 from "./feathers.service";
export class ReportService extends BaseService {
    constructor(feathers) {
        super("report", feathers.app);
    }
}
ReportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReportService_Factory() { return new ReportService(i0.ɵɵinject(i1.FeathersService)); }, token: ReportService, providedIn: "root" });
